import { createApiQueryOptions } from './createApiQueryOptions';
import { QueryClientInstance } from './queryClientInstance';
import { useApisClientContext } from '../Providers';
export const createApiQuery = _ref => {
  let {
    methodConfig
  } = _ref;
  const queryOptionsBuilder = createApiQueryOptions({
    methodConfig
  });
  return args => {
    const {
      httpClient,
      request,
      options
    } = args;
    const queryClient = QueryClientInstance.Instance.queryClient;
    const queryOptions = queryOptionsBuilder({
      httpClient,
      request,
      options
    });
    return queryClient.fetchQuery({
      ...queryOptions
    });
  };
};
export const createApiQueries = _ref2 => {
  let {
    apiConfig
  } = _ref2;
  return Object.keys(apiConfig).reduce((acc, methodName) => {
    const methodConfig = apiConfig[methodName];
    const fetchFn = createApiQuery({
      methodConfig
    });
    return {
      ...acc,
      [methodName]: fetchFn
    };
  }, {});
};
export const createApiQueriesClient = _ref3 => {
  let {
    apiConfig,
    apiQueries
  } = _ref3;
  return args => Object.keys(apiConfig).reduce((acc, methodName) => ({
    ...acc,
    [methodName]: (request, options) => apiQueries[methodName]({
      request,
      options,
      ...args
    })
  }), {});
};
export const createApiUseQueries = _ref4 => {
  let {
    apiQueries
  } = _ref4;
  return () => {
    const {
      httpClient
    } = useApisClientContext();
    return Object.keys(apiQueries).reduce((acc, methodName) => ({
      ...acc,
      [methodName]: (request, options) => apiQueries[methodName]({
        httpClient,
        request,
        options
      })
    }), {});
  };
};
//# sourceMappingURL=createApiQuery.js.map